/* eslint-disable @typescript-eslint/no-explicit-any */
import Cookies from 'js-cookie';

export const cookieUtils = (() => {
  const setCookie = (
    name: string,
    value: string,
    secToExpire: number,
    dontEscape = false,
    acceptBlankCookie = false,
  ) => {
    const expireDate = secToExpire ? new Date(new Date().getTime() + secToExpire * 1000) : undefined;

    if (value !== null && (value !== '' || acceptBlankCookie)) {
      const cookieValue = setValue(value, dontEscape);

      Cookies.set(name, cookieValue, {
        expires: expireDate,
        secure: true,
      });
    }
  };

  const getCookie = (name: string) => {
    if (typeof window === 'undefined') {
      return null;
    }
    if (document.cookie.length > 0) {
      return Cookies.get(name);
    }
    return null;
  };

  const deleteCookie = (name: string, overRideDomain?: string) => {
    const domain = overRideDomain ? overRideDomain : `.${(window as any).oc.cookieDomain}`;

    Cookies.remove(name, { domain, path: '/' });
  };

  const getCookieArray = function (name: string) {
    const cookies = Cookies.get(name);
    if (!cookies) {
      return;
    }

    const cookieArray = cookies.split('~');
    const cookieObj = {} as Record<string, string>;

    for (let i = 0, len = cookieArray.length; i < len; i += 2) {
      if (cookieArray[i + 1] === undefined) {
        return null;
      }
      cookieObj[cookieArray[i]] = cookieArray[i + 1];
    }

    return cookieObj;
  };

  const getCookieArraySize = function (obj: Record<string, string>) {
    let size = 0,
      key;
    for (key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) size++;
    }
    return size;
  };

  const setCookieArray = (name: string, array: Record<string, string>, secToExpire?: number) => {
    const expireDate = new Date(new Date().getTime() + (secToExpire || 24 * 3600) * 1000);

    const cookieValue = createCookieString(array);

    Cookies.set(name, cookieValue, {
      domain: (window as any).oc.cookieDomain,
      expires: expireDate,
      secure: true,
    });
  };

  const addCookieArray = function (name: string, key: string, value: string, secToExpire: number) {
    let cookieArray = getCookieArray(name);
    if (!cookieArray) {
      cookieArray = {} as Record<string, string>;
    }
    cookieArray[key] = value;
    setCookieArray(name, cookieArray, secToExpire);
  };

  const deleteCookieArray = (name: string, element: string) => {
    const cookieArray = getCookieArray(name);
    if (cookieArray) {
      delete cookieArray[element as any];
      setCookieArray(name, cookieArray);
    }
  };

  return {
    addCookieArray,
    deleteCookie,
    deleteCookieArray,
    getCookie,
    getCookieArray,
    getCookieArraySize,
    setCookie,
    setCookieArray,
  };
})();

export function setValue(value: string, dontEscape: boolean): string {
  if (!dontEscape) {
    return encodeURI(value);
  }
  return value;
}

export function createCookieString(array: Record<string, string>): string {
  return Object.entries(array)
    .map(([key, value]) => key + '~' + value)
    .join('~');
}
